import React from 'react';
import Carousel from 'react-material-ui-carousel'
import InstructorsComponent from './InstructorsComponent';
import Instructor2 from './images/Instructor2.webp';
import Instructor3 from './images/Instructor3.webp';
import Instructor1 from './images/Instructor1.webp';

function InstructorsCarousel(props) {
    const { isSmallScreen } = props;

    var itemsWeb = [
        [
            {
                name: "Puneet Kumar Bhatia",
                content: "20 years of experience in IT with expertise in Requirement Analysis, Product Development & Testing (QA), Delivery/Release management, DevOps practices, cloud computing, requirement analysis, Software project/product life cycle implementation and Agile Methodologies.",
                link: "https://media.licdn.com/dms/image/v2/C5603AQHrbmCdtTb2xA/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1590382473746?e=2147483647&v=beta&t=6ZddQ8t-EkfgQeMvYMzHO6CwvZri-EqZII2XoZq6gVI"

            },
            {
                name: "Ritvik Saxena",
                content: "Ritvik Saxena, an experienced AWS Cloud and DevOps Trainer, is dedicated to empowering learners with industry-ready skills through hands-on training in AWS, DevOps tools, automation, and cloud technologies, bridging the gap between theory and practice.",
                link: Instructor1

            },
            {
                name: "Tanvi Puri",
                content: "Tanvi is highly motivated DevOps Enthusiast with extensive experience in automating software development lifecycles using Azure DevOps, Docker, Kubernetes, and Ansible. Proven ability to design, implement, and manage CI/CD pipelines for efficient app delivery",
                link: Instructor2

            }
        ],
        [
            {
                name: "Aneesh Kumar",
                content: "Aneesh is a certified IT expert in AWS and Azure, working as a DevOps Architect and specializing in cloud and infrastructure. He designs and builds entire IT setups for important apps in banking, insurance, and finance.",
                link: Instructor3

            },
            {
                name: "Loksai",
                content: "Loksai, a DevOps Architect and Trainer, specializes in GIT, AWS DevOps, Azure DevOps, Kubernetes, ArgoCD, Docker, Terraform, Ansible, and Jenkins, providing hands-on training to streamline CI/CD pipelines and automate infrastructure.",
                link: ""

            },
            {
                name: "Kastro Kiran",
                content: "With 8+ years in Structural and Construction Engineering, He specializes in self-curing concrete, ML for shrinkage prediction, AWS Cloud, DevOps tools, corporate training, and academia-industry collaboration, delivering practical and innovative solutions.",
                link: "https://media.licdn.com/dms/image/v2/D5603AQHJB_lF1d9OSw/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1718971147142?e=2147483647&v=beta&t=bH5cPcsE5TGh7h6qiC013cDOft-X3k2qFYO0mAmo7nI"

            }
        ],
        [
            {
                name: "Arun Raju",
                content: "Arun Raju, a DevOps Engineer and Trainer, excels in building scalable, automated, and secure infrastructure. He specializes in Linux, Shell Scripting, Git, Jenkins, Docker, Terraform, and Ansible, empowering teams with practical, hands-on DevOps expertise.",
                link: "https://media.licdn.com/dms/image/v2/D5603AQGB4paImesN2A/profile-displayphoto-scale_200_200/B56Zf.Lul_HoAY-/0/1752316193521?e=2147483647&v=beta&t=B_F6LlxDuUIgofhq9OmP4mvOqmPNlsRbFsCupZngPCo"

            },
            {
                name: "Gareth Ruhan",
                content: "Gareth Ruhan, a certified Cloud Consultant and Microsoft Certified Trainer (MCT), specializes in Azure technologies. He delivers training and implements data solutions and DevOps projects using Azure services, with expertise in Azure Data, DevOps, and Power BI.",
                link: "https://media.licdn.com/dms/image/v2/D4D03AQHzi6_ozDYR7w/profile-displayphoto-shrink_200_200/B4DZXSfa_EHAAY-/0/1742993207806?e=2147483647&v=beta&t=KQNmhOpVCROoqVTG9MkVVUgkz-sA25CVqePl6hSCjeY"

            },
        ]

    ];

    var itemsMobile =
        [
            {
                name: "Puneet Kumar Bhatia",
                content: "20 years of experience in IT with expertise in Requirement Analysis, Product Development & Testing (QA), Delivery/Release management, DevOps practices, cloud computing, requirement analysis, Software project/product life cycle implementation and Agile Methodologies.",
                link: "https://media.licdn.com/dms/image/v2/C5603AQHrbmCdtTb2xA/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1590382473746?e=2147483647&v=beta&t=6ZddQ8t-EkfgQeMvYMzHO6CwvZri-EqZII2XoZq6gVI"

            },
            {
                name: "Ritvik Saxena",
                content: "Ritvik Saxena, an experienced AWS Cloud and DevOps Trainer, is dedicated to empowering learners with industry-ready skills through hands-on training in AWS, DevOps tools, automation, and cloud technologies, bridging the gap between theory and practice.",
                link: Instructor1

            },
            {
                name: "Tanvi Puri",
                content: "Tanvi is highly motivated DevOps Enthusiast with extensive experience in automating software development lifecycles using Azure DevOps, Docker, Kubernetes, and Ansible. Proven ability to design, implement, and manage CI/CD pipelines for efficient application delivery",
                link: Instructor2
            },
            {
                name: "Aneesh Kumar",
                content: "Aneesh is a certified IT expert in AWS and Azure, working as a DevOps Architect and specializing in cloud and infrastructure. He designs and builds entire IT setups for important apps in banking, insurance, and finance.",
                link: Instructor3

            },
            {
                name: "Loksai",
                content: "Loksai is a DevOps Architect and Corporate Trainer specializes in modern DevOps practices, equipping professionals with in-depth expertise across various platforms and tools. With a strong command over GIT, AWS DevOps, Azure DevOps Services, Kubernetes, ArgoCD, Docker, Terraform, Ansible, and Jenkins, they provide hands-on training to help organizations streamline CI/CD pipelines and infrastructure automation.",
                link: ""

            },
            {
                name: "Kastro Kiran",
                content: "8+ years of experience in Structural and Construction Engineering with expertise in Self-Curing Concrete Properties, Machine Learning for Shrinkage Prediction, AWS Cloud, DevOps tools (GIT, GitHub, Jenkins, Maven, Kubernetes, Docker, and Terraform), Corporate Training, Academia-Industry Collaboration, and delivering practical, innovative solutions.",
                link: "https://media.licdn.com/dms/image/v2/D5603AQHJB_lF1d9OSw/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1718971147142?e=2147483647&v=beta&t=bH5cPcsE5TGh7h6qiC013cDOft-X3k2qFYO0mAmo7nI"

            },
            {
                name: "Arun Raju",
                content: "Arun Raju, a DevOps Engineer and Trainer, excels in building scalable, automated, and secure infrastructure. He specializes in Linux, Shell Scripting, Git, Jenkins, Docker, Terraform, and Ansible, empowering teams with practical, hands-on DevOps expertise.",
                link: "https://media.licdn.com/dms/image/v2/D5603AQGB4paImesN2A/profile-displayphoto-scale_200_200/B56Zf.Lul_HoAY-/0/1752316193521?e=2147483647&v=beta&t=B_F6LlxDuUIgofhq9OmP4mvOqmPNlsRbFsCupZngPCo"

            },
            {
                name: "Gareth Ruhan",
                content: "Gareth Ruhan, a certified Cloud Consultant and Microsoft Certified Trainer (MCT), specializes in Azure technologies. He delivers training and implements data solutions and DevOps projects using Azure services, with expertise in Azure Data, DevOps, and Power BI.",
                link: "https://media.licdn.com/dms/image/v2/D4D03AQHzi6_ozDYR7w/profile-displayphoto-shrink_200_200/B4DZXSfa_EHAAY-/0/1742993207806?e=2147483647&v=beta&t=KQNmhOpVCROoqVTG9MkVVUgkz-sA25CVqePl6hSCjeY"

            }
        ];

        const [clicked, setClicked] = React.useState(isSmallScreen ? true : false);


    return (
        <>
            {
                isSmallScreen
                    ?
                    <Carousel
                        animation={"slide"}
                        autoPlay="false"
                        navButtonsAlwaysVisible="true"
                        interval={40000}
                    >
                        {
                            itemsMobile.map((item, itemIndex) =>
                                <CarouselCard key={itemIndex} item={item} isSmallScreen={isSmallScreen} setClicked={setClicked}
                            clicked={clicked}/>
                            )
                        }
                    </Carousel>
                    :
                    <Carousel
                        animation={"slide"}
                        autoPlay="false"
                        navButtonsAlwaysVisible="true"
                        interval={40000}
                    >
                        {
                            itemsWeb.map((group, groupIndex) =>
                                <Item key={groupIndex} group={group} setClicked={setClicked}
                            clicked={clicked}/>
                            )
                        }
                    </Carousel>
            }
        </>
    )
}

function Item(props) {
    const { group, setClicked, clicked } = props;

    return (
        <div style={{ display: "flex", margin: "auto 10px" }}>
            {group.map((item, itemIndex) => (
                <CarouselCard 
                item={item}
                setClicked={setClicked}
                clicked={clicked} />
            ))}
        </div>
    )
}

function CarouselCard(props) {
    const { item, isSmallScreen, setClicked, clicked } = props;

    return (
        <InstructorsComponent isSmallScreen={isSmallScreen}
            url={item.link}
            name={item.name}
            content={item.content}
            setClicked={setClicked}
            clicked={clicked}
        />
    )
}

export default InstructorsCarousel;